export enum ModeForm {
  View = "View",
  Edit = "Edit",
  Create = "Create",
  Delete = "Delete",
}

export enum LabelType {
  name = "name",
  email = "email",
  legalName = "legalName",
}
